import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import { CommentingPromptWrapperProps } from './types'

const PromptWrapper = styled.div<CommentingPromptWrapperProps>`
  ${({ type }) => css`
    box-sizing: border-box;
    ${type === 'answer' &&
    `margin-top: 0.625rem;
  padding-left: 40px;
  position: relative;`}
  `}
`

const CommentingPromptWrapper: FunctionComponent<
  CommentingPromptWrapperProps
> = ({ type, children }) => (
  <PromptWrapper type={type}>{children}</PromptWrapper>
)

export default CommentingPromptWrapper
